import React, {useState} from 'react';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import _ from 'lodash';
import classnames from 'classnames/bind';
import ClickOut from 'react-click-out';
import {ICountry, IState, LocationCategory, Replacement} from '../../../interface';
import actions from '../../../redux/actions';
import style from './index.module.scss';
import localesReplacement from '../../../utils/localesReplacement';
import {NODISTANCECOUNTRIES, RETAIL_OUTLET} from '../../../constants';

const cx = classnames.bind(style);

export interface IProps {
  state: IState;
  sort: string;
  replacements: Replacement;
  setAccord: (value: boolean) => void;
  setSort: (value: string) => void;
  country: ICountry;
  locationCategoriesList: LocationCategory[] | null;
}

//Sort dropdown and map view(only for mobile) component with redu
export const SortSection = (props: IProps) => {
  const {
    state,
    sort,
    replacements,
    setAccord,
    setSort,
    country,
    locationCategoriesList,
  } = props;
  const [dropVisible, setdropVisible] = useState<boolean>(false);
  const sorts = [
    {label: 'Name', value: 'name'},
    {label: 'Distance', value: 'distanceInMiles'},
  ];
  //Change by dropdown options is selectd
  const selectSort = (value: string) => {
    setSort(value);
    setdropVisible(false);
  };
  const label = _.isEmpty(_.find(sorts, ['value', sort]))
    ? 'Name'
    : _.find(sorts, ['value', sort])?.label;

  const locCatNames = _.map(
    state.filter.locationCategories,
    (lc) =>
      _.find(locationCategoriesList, (l) => _.isEqual(lc, l.id.toString()))
        ?.name,
  );
  return (
    <div className={cx('section')}>
      {/* Sort dropdown */}
      <div className={cx('sort-section')}>
        <strong>{localesReplacement(replacements, 'Sort by')} :</strong>
        <ClickOut
          className='click-out'
          onClickOut={() => setdropVisible(false)}
        >
          <div className={cx('selected')}>
            <span
              className={cx('selected-text')}
              onClick={() => setdropVisible(!dropVisible)}
            >
              {localesReplacement(replacements, label as string)}
            </span>
            {/* layout of dropdown */}
            <ul className={cx({visible: dropVisible})}>
              {_.map(sorts, (obj, index) => (
                <li key={index} onClick={() => selectSort(obj.value)}>
                  <span className='link' role='link'>
                    {localesReplacement(replacements, obj.label)}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </ClickOut>
      </div>
      {/** trigger map view */}
      {!!country.isoCode && (
        <>
          {_.includes(NODISTANCECOUNTRIES, country.isoCode) &&
          _.includes(locCatNames, RETAIL_OUTLET) ? null : (
            <div className={cx('view-section')}>
              <span
                className={`button ${cx('map-view')}`}
                role='button'
                onClick={() => setAccord(true)}
              >
                {localesReplacement(replacements, 'Map view')}
              </span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  state: state,
  sort: state.sort,
  replacements: state.replacements,
  country: state.country,
  locationCategoriesList: state.locationCategoriesList,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setSort: (value: string) => dispatch(actions.setSort(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SortSection);
